import { Component } from 'react'

/**
 * Base component which you can extend to use logic of switching.
 *
 * !! Do not forget to extend state of component instead of create new one
 * if you want ot use state:
 *
 * `this.state.someNewAttribute = 'something'`
 *
 * @return {Component} Component — ComponentSwitcher
 */
export default class ComponentSwitcher extends Component {
  constructor(props) {
    super(props)

    this.state = {
      active: 0,
    }
  }

  /**
   * Method to handle click on list's item to activate it
   *
   * @param {number} index - active item index
   * @return {void} void
   */
  handleClick = index => {
    this.setState({
      active: index,
    })
  }

  render() {
    return null
  }
}
